<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div :class="{'selected':Active,'fade':!Active}" class="avatar">

    <v-avatar
        color="grey"
        size="64px"

    >
      <img
          v-if="user.picture"
          :src="user.picture"
          alt="Avatar"
      >
      <v-icon v-else x-large>mdi-account-circle</v-icon>

    </v-avatar>
    <v-badge :color="active?CustomerStyle.TypeClass[user.department]:'grey'" left offset-x="-40px" offset-y="-20px"
             overlap
             top>
      <template v-slot:badge>
        {{ user.department }}
      </template>
    </v-badge>

    <!--:color="user.orderUser && user.orderUser.com_option?OrderUserConst.color(user.orderUser.com_option):'grey'"-->
    <!--<v-badge v-if="user.orderUser && user.orderUser.com_option!==OrderUserConst.COM_OPTION_NORMAL"-->
    <v-badge v-if="user.orderUser && user.orderUser.com_option!==OrderUserConst.COM_OPTION_NORMAL"
             :color="user.orderUser.com_option?OrderUserConst.color(user.orderUser.com_option):'grey'"
             bottom left offset-x="0px" offset-y="0px" overlap>
      <template v-slot:badge>
        {{ OrderUserConst.map(user.orderUser.com_option) }}
      </template>
    </v-badge>

    <br/>
    <span class="name"
    >
      {{ user.nickname }}</span>
  </div>

</template>
<style lang="scss" scoped>

.avatar {
  float: left;
  display: block;
  width: 72px;
  text-align: center;

}

.line-through {
  text-decoration: line-through;
}

.fade {
  .v-avatar {
    opacity: 0.2;
  }

  .v-badge {
    opacity: 0.5;
  }

  img {
    filter: grayscale(100%);

  }

  .teal {
    background-color: #8a8a8a !important;
    border-color: #8a8a8a !important;
  }

  .name {
    opacity: 0.5;
  }
}

.selected {
  opacity: 1 !important;
}

.name {
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
}


</style>

<script lang="ts">

import {Component, Prop, Vue} from 'vue-property-decorator'
import {OrderUserConst} from '../../models/OrderUser'
import {User} from '../../models/User'
import {CustomerStyle} from '../Customer/Const'

@Component({
  components: {}
})
export default class Avatar extends Vue {
  @Prop() user: User
  @Prop({
    default: () => {
    }
  }) onClick: Function
  @Prop({
    // default: true,
  }) active: boolean | null

  OrderUserConst = OrderUserConst


  CustomerStyle = CustomerStyle


  get Active() {
    if (this.user === null ||
        this.user.orderUser === undefined ||
        this.user.orderUser === null) return this.active
    if (this.user.orderUser.com_option === OrderUserConst.COM_OPTION_SKIP) return false
    if (this.user.orderUser.com_option === OrderUserConst.COM_OPTION_TIER2) return false
    return this.active
  }

}

</script>
